export default __webpack_public_path__ + "static/media/kneauxLa.d541b519.xml";